import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import styled from 'styled-components';
import { ClinicMasterProduct } from '../../../../apis/clinic-master-products/types';
import PriceEditor from '../../../FormEditors/PriceEditor';

interface ClinicMasterProductEditorProps {
  form: UseFormReturn<ClinicMasterProduct>;
}

const ClinicMasterProductDeliveryPriceEditor = ({ form }: ClinicMasterProductEditorProps) => {
  return (
    <FullWidthContainer>
      <PriceEditor label="Delivery price" control={form.control} name="delivery_price" />
    </FullWidthContainer>
  );
};

export default ClinicMasterProductDeliveryPriceEditor;

const FullWidthContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
`;
